import React, { useEffect } from 'react';

type Props = {
  sectionContainerId: string;
  content: HTMLElement | null;
};

const PortalLayer = ({ sectionContainerId, content }: Props) => {
  const wrapperId = `${sectionContainerId}Wrapper`;

  useEffect(() => {
    if (typeof document === 'undefined') return;

    const wrapper = document.getElementById(wrapperId);

    if (wrapper && content) {
      wrapper.appendChild(content);
      // eslint-disable-next-line no-param-reassign
      content.style.display = 'block';
    }
  }, []);

  return <div id={wrapperId} />;
};

export default PortalLayer;
